
/**
* @memberof rmOBA
* @ngdoc service
* @name rmOrdersUtils
* @description 
*   Set of methods used to help in manipulating orders into the correct format and order.
*/

rmOBA.factory('rmOrdersUtils', function () {

        var orderUtils = {

            /**
            * @memberof rmOrdersUtils
            * @function getCSVHeaders
            * @desc Given a set of orders return an array of headings
            * @param {array} orders The orders array
            * @returns {array} List of order line headings
            */
            getCSVHeaders: function(orders) {
                var headers = [];
                angular.forEach(orders[0], function(val, key) {
                    headers.push(key);
                });
                return headers;
            },

            /**
            * @memberof rmOrdersUtils
            * @function cleanOrders
            * @desc drop down lists within forms save objects out to the scope as values instead of the string values. 
            * This function overwrites the object with the string Value.
            * @param {array} orders The orders array
            * @returns {array} List of order line headings
            */
            cleanOrders: function(orders) {
                // Make a copy of orders
                var csvOrders = angular.copy(orders);

                // If the orderline value is set to an object 
                // - set it to the 'Value' of that object.
                angular.forEach(csvOrders, function(order) {
                    angular.forEach(order, function(value, key, arr) {
                        if (typeof value === 'object' && value !== null) {
                            // console.log(key + ': ', typeof value, value);
                            arr[key] = value.ID;
                        }
                    });
                });

                return csvOrders;
            },

            /**
            * @memberof rmOrdersUtils
            * @function addLocationData
            * @desc Populate each order line with location form data. 
            * If the orderline has a location lookup then populate with saved data.
            * @param {array} orders The saved orders array
            * @param {array} orderLinesData Each order line data row in an array 
            * @param {array} locationData Saved user-input location data
            * @returns {array} orders with location data added
            */
            addLocationData: function(orders, orderLinesData, locationData) {

                // for each order in orderlines
                angular.forEach(orders, function(order) {
                    // for each value in order
                    angular.forEach(order, function(value, key, arr) {

                        // Should we use location data in this field?
                        var index = _.findKey(orderLinesData, ['Field', key]);
                        // console.log('Field: ', key);
                        // console.log('orderLinesData[index].Source: ', orderLinesData[index].Source);
                         if (orderLinesData[index].Source) {
                            if (orderLinesData[index].Source === 'location') {
                                // if so set this field to the corresponding location data field
                                console.log('is Source location');
                                order[key] = locationData[key];
                            }
                        }
                    });
                });
                return orders;
            },


            /**
            * @memberof rmOrdersUtils
            * @function reOrderColumns
            * @desc Reorder columns for output to CSV 
             * @param  {boject} orderLine Completed orderLine from Postage product form 
             * @param  {object} newOrder  The desired order
             * @returns {array}           the values in the desired order
            */
            reOrderColumns: function(orderLine, newOrder) {
                var orderLineSorted = [];
                angular.forEach(orderLine, function(value, key) {
                    if (key === 0 || newOrder[key] === null || newOrder[key] === undefined) {
                        return; // we don't want to add fields with a sort value of 0 to the manifest or CSV
                    }
                    var index = (newOrder[key]-1);
                    orderLineSorted[index] = value;
                });
                
                return orderLineSorted;
            },



            /**
            * @memberof rmOrdersUtils
            * @function sortOrderLines
            * @desc loop through each orderline and save a copy of the values to an array 
            * in the correct order for the format (CSV, Print Manifest, etc)
            * @param  {boject} orderLines Completed orderlines from the previous stage in the app
            * @param  {object} newOrder  The desired order
            * @returns {array}            Ordered Array of order lines
            */
            sortOrderLines: function(orderLines, newOrder) {
                var ordered = [];

                angular.forEach(orderLines, function(obj, index) {
                    ordered.push(orderUtils.reOrderColumns(obj, newOrder));
                });
                // console.log('sortOrderLines: ',ordered);
                return ordered;
            },


            /**
            * @memberof rmOrdersUtils
            * @function orderHeadings
            * @desc  Order an array of headings given a specified order
            * @param  {array} headings A list of Headings 
            * @param  {object} newOrder specifed order to map headings to
            * @return {array}          list of ordered headings. NB: an order value of 0 will prevent the item from being output to the ordered array
            */
            orderHeadings: function(headings, newOrder) {
                var ordered = [];

                angular.forEach(headings, function(key, index, array) {
                    // console.log(key, index);
                    if (newOrder[key] === '0' || newOrder[key] === null || newOrder[key] === undefined) {
                        return; // we don't want to add fields with a sort key of 0 to the manifest or CSV
                    }
                    var newIndex = (newOrder[key]-1);
                    ordered[newIndex] = key;
                });
                // console.log('orderHeadings: ',ordered);
                return ordered;
            }
        };

        return orderUtils;
    });